<template>
  <div id="app">
    <!--  路由地址文件  -->
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue